<sbnb-hero-card
  *ngIf="addonData$ | async as data"
  [active]="data.selectedTier !== 'basic' && (canManageAddons$ | async) === true"
  [useHover]="data.selectedTier === 'basic' && (canManageAddons$ | async) === true"
  [matTooltip]="(canManageAddons$ | async) === false ? 'Renew your subscription to add priority support' : ''">
  <div class="flex items-center justify-between gap-3 flex-wrap">
    <div class="flex flex-1 flex-col content gap-3 max-w-[550px] min-w-[220px]">
      <h4 class="nomargin" [ngClass]="{ 'night-lighter': (canManageAddons$ | async) === false }">Priority Support</h4>

      <div>All of your conversations are marked as priority and answered first</div>
    </div>

    <ng-container>
      <div class="flex flex-wrap gap-3 items-center">
        <sbnb-button
          size="mini"
          [disabled]="(canManageAddons$ | async) === false"
          type="secondary"
          [routerLink]="['/settings', 'support-tiers']">
          {{ data.selectedTier === 'basic' ? 'Activate' : 'Configure' }}
        </sbnb-button>
      </div>
    </ng-container>
  </div>
</sbnb-hero-card>
